import type { RegularSymbolId } from './types';

export type PayoutMatchCount = 3 | 4 | 5;
export type PayoutSymbolId = RegularSymbolId | 'WILD';
export type PayoutTable = Readonly<Record<
  PayoutSymbolId,
  Readonly<Partial<Record<PayoutMatchCount, number>>>
>>;

export const ACTIVE_MATH_MODEL_ID = 'season3-r7' as const;

export const SEASON_2_PAYOUTS: PayoutTable = Object.freeze({
  BEWD: Object.freeze({ 3: 60, 4: 375, 5: 1_000 }),
  DM: Object.freeze({ 3: 40, 4: 200, 5: 500 }),
  JINZO: Object.freeze({ 3: 20, 4: 80, 5: 250 }),
  TW: Object.freeze({ 3: 20, 4: 80, 5: 250 }),
  ACE: Object.freeze({ 3: 10, 4: 50, 5: 180 }),
  KING: Object.freeze({ 3: 10, 4: 50, 5: 180 }),
  QUEEN: Object.freeze({ 3: 5, 4: 25, 5: 95 }),
  JACK: Object.freeze({ 3: 5, 4: 25, 5: 95 }),
  WILD: Object.freeze({ 5: 1_000 }),
});

export const SEASON_3_R7_PAYOUTS: PayoutTable = Object.freeze({
  BEWD: Object.freeze({ 3: 50, 4: 325, 5: 650 }),
  DM: Object.freeze({ 3: 35, 4: 175, 5: 375 }),
  JINZO: Object.freeze({ 3: 20, 4: 75, 5: 200 }),
  TW: Object.freeze({ 3: 20, 4: 75, 5: 200 }),
  ACE: Object.freeze({ 3: 10, 4: 45, 5: 135 }),
  KING: Object.freeze({ 3: 10, 4: 45, 5: 135 }),
  QUEEN: Object.freeze({ 3: 5, 4: 25, 5: 70 }),
  JACK: Object.freeze({ 3: 5, 4: 25, 5: 70 }),
  WILD: Object.freeze({ 5: 650 }),
});

export const ACTIVE_PAYOUTS = SEASON_3_R7_PAYOUTS;
